var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinesswoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M403.2,381.867c0,0-43.733-153.6-43.733-286.933C359.467,21.333,310.4,0,253.867,0 s-105.6,21.333-105.6,94.933c0,115.2-43.733,286.933-43.733,286.933H403.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ABAA5"
    },
    d: "M509.867,512c-5.333-38.4-9.6-74.667-11.733-93.867c-5.333-54.4-34.133-57.6-34.133-57.6 c-8.533-10.667-102.4-38.4-102.4-38.4s-10.667,66.133-19.2,122.667c-2.133,13.867-9.6,38.4-20.267,66.133h187.733V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ABAA5"
    },
    d: "M188.8,512c-10.667-27.733-18.133-52.267-20.267-66.133C160,390.4,149.333,323.2,149.333,323.2 S56.533,350.933,48,361.6c0,0-28.8,2.133-34.133,57.6c-1.067,18.133-6.4,54.4-11.733,92.8H188.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M320,248.533c1.067-3.2,2.133-5.333,3.2-8.533c24.533-54.4,20.267-135.467,20.267-135.467 c-25.6-6.4-42.667-19.2-60.8-37.333c-27.733,28.8-67.2,46.933-107.733,46.933c-2.133,0-5.333,0-7.467,0c0,0,0,0,0,1.067 c-2.133,24.533,0,65.067,7.467,88.533C179.2,217.6,185.6,234.667,193.067,249.6v35.2l0,0L142.933,384l46.933,128h124.8l35.2-115.2 L320,283.733V248.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B64C"
    },
    d: "M213.333,350.933c86.4-42.667,106.667-102.4,106.667-102.4l0,0c0,0-28.8,48-66.133,44.8 c-37.333-3.2-60.8-44.8-60.8-44.8l0,0v35.2l0,0l-44.8,91.733C167.467,368,206.933,354.133,213.333,350.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EAE9"
    },
    d: "M349.867,512V318.933H339.2c-3.2,43.733-39.467,78.933-84.267,78.933s-81.067-34.133-84.267-78.933 H160V512H349.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M355.2,182.4c-2.133,18.133-11.733,34.133-21.333,34.133S318.933,201.6,322.133,182.4 c2.133-18.133,11.733-34.133,21.333-34.133C352,148.267,357.333,163.2,355.2,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M149.333,186.667c2.133,18.133,11.733,34.133,21.333,34.133c9.6,0,14.933-14.933,11.733-34.133 c-3.2-19.2-11.733-34.133-21.333-34.133C152.533,152.533,147.2,167.467,149.333,186.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6B9"
    },
    d: "M329.6,397.867c-2.133,20.267-13.867,65.067-27.733,114.133h55.467 c25.6-51.2,54.4-107.733,54.4-107.733l-30.933-22.4l18.133-8.533l-2.133-3.2C381.867,345.6,362.667,323.2,341.333,304 c-7.467-6.4-19.2-14.933-21.333-20.267C320,283.733,336,340.267,329.6,397.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6B9"
    },
    d: "M154.667,512h55.467c-13.867-49.067-25.6-92.8-27.733-114.133c-6.4-57.6,10.667-115.2,10.667-115.2 c-2.133,5.333-14.933,13.867-21.333,20.267c-22.4,19.2-40.533,40.533-55.467,66.133l-2.133,3.2l18.133,8.533l-30.933,22.4 C100.267,404.267,129.067,460.8,154.667,512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesswoman);
export default __webpack_public_path__ + "static/media/businesswoman.d4d5dfc043a078e727304beeb6778b45.svg";
export { ForwardRef as ReactComponent };